<template>
    <div :class="wrapperClass">
        <div class="gritter-item">
            <div class="gritter-img-container" v-if="image"><img :src="image" class="gritter-image"></div>
            <div :class="contentClass">
                <button class="gritter-close" @click.prevent="close" v-if="!sticky">Schliessen</button>
                <span class="gritter-title">{{ title }}</span>
                <p>{{ description }}</p>
                <button class="btn btn-sm btn-secondary" @click.prevent="doAction" v-if="action && actionText">{{ actionText }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: [String, Number],
            timeout: Number,
            sticky: Boolean,
            title: String,
            description: String,
            action: Function,
            actionText: String,
            image: String,
            imageRounded: Boolean,
            color: String,
        },

        computed: {
            wrapperClass() {
                return {
                    'gritter-item-wrapper': true,
                    'img-rounded': this.imageRounded,
                    clean: !this.color,
                    [`color ${this.color}`]: !!this.color,
                };
            },

            contentClass() {
                return {
                    'gritter-content': true,
                    'gritter-with-image': !!this.image,
                    'gritter-without-image': !this.image,
                };
            },
        },

        methods: {
            close() {
                this.$store.commit('notifications/pop', this.id);
            },

            doAction() {
                this.action();
                this.close();
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .gritter-close {
        padding: 0;
        text-align: left;
        border: none;
    }
</style>
